module.exports = __webpack_public_path__ + "static/media/hero.8927d613.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/Landing/hero.webp
// module id = 197
// module chunks = 51